export function getFuelTypeIcons({ isPHEV, isElectric }) {
  switch (true) {
    case isPHEV: {
      return ['icon-power-cord-thin', 'icon-droplet-contrast1'];
    }
    case isElectric: {
      return ['icon-power2'];
    }
    default: {
      return ['icon-gas'];
    }
  }
}
